export default function MediaUploadBox({ mediaType = "image", busy, onUpload }) {
  return (
    <label className="flex cursor-pointer flex-col items-center justify-center rounded-xl border border-dashed border-gray-300 bg-slate-50 px-4 py-6 text-center text-sm text-slate-500 transition hover:border-slate-400 hover:bg-slate-100">
      <input
        type="file"
        className="hidden"
        disabled={busy}
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (file) onUpload(file, mediaType);
          e.target.value = "";
        }}
      />
      {busy ? "Uploading…" : mediaType === "image" ? "Choose image file" : `Upload ${mediaType}`}
    </label>
  );
}
